import React, { useState } from 'react';
import cx from 'classnames';
import { createPortal } from 'react-dom';

import FullPageOverlay from '@marketing/components/full_page_overlay';
import SectionHeader from '@marketing/components/section_header';

import FocusedQuestionCard from './assets/focused_question_card.png';
import MikeHeadshot from './assets/mike_headshot.png';
import PlayIcon from './assets/play_icon.svg';
import QuestionCardsBg from './assets/question_cards_bg.png';
import VideoThumbnail from './assets/video_thumbnail.png';
import marketingStyles from '@marketing/style.module.scss';
import styles from './style.module.scss';

const VideoBasedLearningSection: React.FC<{}> = (props) => {
  const [displayVideoPlayer, setDisplayVideoPlayer] = useState<boolean>(false);

  return (
    <div style={{ position: 'relative' }}>
      <div className="d-flex flex-column gap-l">
        <SectionHeader
          subtitle="Want to go further? We also include 290+ curated lessons shaped by student feedback to deliver material in the way you learn best."
          supertitle="Video based learning"
          supertitleIcon={PlayIcon}
          title="Video explanations for every question"
        />

        <div className={styles.questionCardsContainer} style={{ position: 'relative' }}>
          <div className="hidden-xs hidden-sm" style={{ position: 'absolute' }}>
            <img
              alt="Array of different types of questions that you can see video explanations for"
              loading="lazy"
              src={QuestionCardsBg}
            />
          </div>

          <div
            className={cx(styles.videoThumbnailContainer, 'd-flex flex-column gap-s')}
            style={{ position: 'relative', zIndex: 1 }}
          >
            <div>
              <img
                alt="Thumbnail of an explanation video with a play button"
                height="200px"
                loading="lazy"
                onClick={() => setDisplayVideoPlayer(true)}
                src={VideoThumbnail}
                style={{
                  border: '1px solid #BEC7CC',
                  borderRadius: 16,
                  boxShadow: '0 49px 29px rgba(0, 0, 0, 0.05), 0 22px 22px rgba(0, 0, 0, 0.08), 0 5px 12px rgba(0, 0, 0, 0.09)',
                  cursor: 'pointer',
                }}
                width="347px"
              />
            </div>

            <div>
              <img
                alt="Question that is related to the explanation video"
                height="173px"
                loading="lazy"
                src={FocusedQuestionCard}
                width="390px"
              />
            </div>
          </div>
        </div>
      </div>

      {
        displayVideoPlayer && (
          createPortal(
            <>
              <div
                className={styles.pageOverlay}
                onClick={() => setDisplayVideoPlayer(false)}
              />

              <div className={cx(marketingStyles.purpleNoiseBg, styles.videoPlayerContainer)}>
                <div className={cx(styles.videoPlayerWrapper, 'd-flex flex-column')}>
                  <div
                    className="align-items-center bg-white d-flex gap-s"
                    style={{ borderRadius: '12px 12px 0 0', padding: 10 }}
                  >
                    <img alt="Mike McGarry headshot" height="30px" src={MikeHeadshot} width="30px" />

                    <div className="flex-1 small"><strong>Mike McGarry</strong></div>

                    <div>
                      <a className="small text-body" onClick={() => setDisplayVideoPlayer(false)}>
                        close video
                      </a>
                    </div>
                  </div>

                  <video autoPlay className={styles.videoPlayer} controls style={{ borderRadius: '0 0 12px 12px' }}>
                    <source src="https://d296n67kxwq0ge.cloudfront.net/audio_video/a05f3ea3db72c6a8c99118717fc46664034ca3bb-video-15457/web.mp4" type="video/mp4" />
                    <source src="https://d296n67kxwq0ge.cloudfront.net/audio_video/a05f3ea3db72c6a8c99118717fc46664034ca3bb-video-15457/web_webm.webm" type="video/webm" />
                  </video>
                </div>
              </div>
            </>,
            document.body
          )
        )
      }
    </div>
  );
};

export default VideoBasedLearningSection;
